import { render, staticRenderFns } from "./InvoiceForm.vue?vue&type=template&id=38e4734e&scoped=true&"
import script from "./InvoiceForm.vue?vue&type=script&lang=ts&"
export * from "./InvoiceForm.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceForm.vue?vue&type=style&index=0&id=38e4734e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e4734e",
  null
  
)

export default component.exports